import styled from 'styled-components'

import Icon from 'components/UIKit/Icon'

const BackIcon = styled(Icon)`
  margin-right: ${props => props.theme.spacing.s};
`

export default BackIcon
